import React, {useState, useEffect, useContext} from "react";
import axios from "@common/axios";
import ListItem from "@common/ListItem";
import ListGroup from "@common/ListGroup";
import {UserContext} from "@context/UserContext";
import {TemplateContext} from "@common/context/TemplateContext";
import {BrandContext} from "@context/BrandContext";
import {ContentContext} from "@context/ContentContext";
import useCurrentConcept from "@hooks/useCurrentConcept";
import CircularLoader from "@common/CircularLoader";

const LessonNavigation = props => {
    const {grouping = true, tabIndex = 0} = props;
    const brandConfig = useContext(BrandContext);
    const [isLoading, setLoading] = useState(true);
    const {user, setUser} = useContext(UserContext);
    const {singlePage} = useContext(TemplateContext);
    const {content} = useContext(ContentContext);
    const [enabledConcepts, setEnabledConcepts] = useState([]);
    const {loadCurrentConcept} = useCurrentConcept();
    let otherListGroupOptions  = {}
    if (props.indicatorPlacement) otherListGroupOptions.indicatorPlacement = props.indicatorPlacement;

    const loadEnabledConcepts = () => {
        axios.get('/web/ui/content/user/enabledConcepts')
            .then(response => {
                setEnabledConcepts(response.data);
                setLoading(false);
            });
    };

    useEffect(() => {
        if(user !== undefined && user.student && brandConfig.disableConcepts) {
            loadEnabledConcepts();
        } else {
            setLoading(false);
        }
    }, [user, content]);

    if(isLoading) {
        return <CircularLoader pageCentered={false}/>
    }

    if (grouping !== true) {
        if (enabledConcepts === undefined || enabledConcepts.length == 0) {
            return <ListItem disabled={true}>You have no active {brandConfig.conceptsName}</ListItem>;
        } else {
            return (
                <>
                    {enabledConcepts.map((enabledConcept, index) => {
                        const handleOnClick = () => {
                            if (enabledConcept.conceptId) {
                                if (singlePage) {
                                    loadCurrentConcept(enabledConcept.conceptId);
                                } else {
                                    window.location.href = '/controlCentre/navigateSyllabuses.action?conceptId=' + enabledConcept.conceptId;
                                }
                            }
                        }

                        return <ListItem key={index} tabIndex={index == 0 ? 0 : -1} onClick={handleOnClick}>
                            <span className="ch-dashboard-lesson-link">{enabledConcept.syllabusName}<span className="material-icons">chevron_right</span>{enabledConcept.topicName}<span className="material-icons">chevron_right</span>{enabledConcept.conceptName}</span>
                        </ListItem>
                    })}
                </>
            )
        }
    }

    if (enabledConcepts === undefined || enabledConcepts.length == 0) {
        return (
            <ListGroup title={'My latest '+brandConfig.testsName}>
                <ListItem disabled={true}>You have no active {brandConfig.conceptsName}</ListItem>
            </ListGroup>
        );
    }

    return (
        <ListGroup title={'Enabled ' + (brandConfig !== undefined && brandConfig.conceptsName ? brandConfig.conceptsName.toLowerCase() : 'lessons')} {...otherListGroupOptions}>
            {enabledConcepts.map((enabledConcept, index) => {
                const handleOnClick = () => {
                    if (enabledConcept.conceptId) {
                        if(singlePage) {
                            loadCurrentConcept(enabledConcept.conceptId);
                        } else {
                            window.location.href = '/controlCentre/navigateSyllabuses.action?conceptId=' + enabledConcept.conceptId;
                        }
                    }
                }

                return <ListItem key={index}  onClick={handleOnClick}>
                    {enabledConcept.conceptName}
                </ListItem>
            })}
        </ListGroup>
    );
}

export default LessonNavigation;
